window.$ = window.jQuery = require('jquery');

window.Cookies = require('js-cookie');

// Javascript librairy and additionnals CSS

window.SwipeListener = require('swipe-listener');

require("html5shiv");
require('bootstrap/dist/js/bootstrap.js');
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap-colorpicker/dist/js/bootstrap-colorpicker.js');
require('bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css');
require('bootstrap-confirmation2/bootstrap-confirmation.js');

require("@fancyapps/fancybox/dist/jquery.fancybox.min.js");
require("@fancyapps/fancybox/dist/jquery.fancybox.min.css");
require("jquery-mousewheel");
require("vegas/dist/vegas.js");
require("vegas/dist/vegas.css");
require("./bxslider-4-master/src/js/jquery.bxslider.js");
require("./bxslider-4-master/src/css/jquery.bxslider.css");

// ---------------------------------------------
// Codemirror main lib
window.CodeMirror = require("codemirror/lib/codemirror.js");
require("codemirror/lib/codemirror.css");
//Theme
require("codemirror/theme/monokai.css");
// Language mode
require("codemirror/mode/htmlmixed/htmlmixed.js");
require("codemirror/mode/css/css.js");
require("codemirror/mode/javascript/javascript.js");
// Additionnal Addons
require("codemirror/addon/edit/matchbrackets.js");
require("codemirror/addon/edit/closebrackets.js");
require("codemirror/addon/dialog/dialog.js");
require("codemirror/addon/dialog/dialog.css");
// Code Folding
require("codemirror/addon/fold/foldcode.js");
require("codemirror/addon/fold/foldgutter.js");
require("codemirror/addon/fold/brace-fold.js");
require("codemirror/addon/fold/foldgutter.css");
// Fullscreen
require("codemirror/addon/display/fullscreen.js");
require("codemirror/addon/display/fullscreen.css");
// Search (Ctrl+F)
require("codemirror/addon/search/searchcursor.js");
require("codemirror/addon/search/search.js");
require("codemirror/addon/search/jump-to-line.js");
// Autocompletion (Ctrl+Space)
require("codemirror/addon/hint/show-hint.js");
require("codemirror/addon/hint/show-hint.css");
require("codemirror/addon/hint/html-hint.js");
require("codemirror/addon/hint/css-hint.js");
require("codemirror/addon/hint/javascript-hint.js");
// Custom initialisation script
require("./admin/js/codemirror.js");
// ---------------------------------------------

//console.log(jQuery.fn)
//require('select2/dist/js/select2.full.js');
//require('select2/dist/css/select2.css');

require('jquery-ui/themes/base/all.css');

// require("jquery-ui/ui/core.js"); // deprecated script
// replace by the following script
require("jquery-ui/ui/version.js");
require("jquery-ui/ui/data");
require("jquery-ui/ui/disable-selection");
require("jquery-ui/ui/focusable");
require("jquery-ui/ui/form");
require("jquery-ui/ui/keycode");
require("jquery-ui/ui/labels");
require("jquery-ui/ui/jquery-patch.js");
require("jquery-ui/ui/plugin");
require("jquery-ui/ui/safe-active-element");
require("jquery-ui/ui/safe-blur");
require("jquery-ui/ui/scroll-parent");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/unique-id");
require("jquery-ui/ui/position.js");

require("jquery-ui/ui/position.js");
require("jquery-ui/ui/widget.js");
require("jquery-ui/ui/widgets/mouse.js");
require("jquery-ui/ui/widgets/draggable.js");
require("jquery-ui/ui/widgets/droppable.js");
require("jquery-ui/ui/widgets/resizable.js");
require("jquery-ui/ui/widgets/selectable.js");
require("jquery-ui/ui/widgets/sortable.js");
require("jquery-ui/ui/widgets/accordion.js");
require("jquery-ui/ui/widgets/autocomplete.js");
require("jquery-ui/ui/widgets/button.js");
require("jquery-ui/ui/widgets/datepicker.js");
require("jquery-ui/ui/widgets/dialog.js");
require("jquery-ui/ui/widgets/menu.js");
require("jquery-ui/ui/widgets/progressbar.js");
require("jquery-ui/ui/widgets/slider.js");
require("jquery-ui/ui/widgets/spinner.js");
require("jquery-ui/ui/widgets/tabs.js");
//require("jquery-ui/ui/widgets/tooltip.js");
require("jquery-ui/ui/effect.js");
require("jquery-ui/ui/effects/effect-blind.js");
require("jquery-ui/ui/effects/effect-bounce.js");
require("jquery-ui/ui/effects/effect-clip.js");
require("jquery-ui/ui/effects/effect-drop.js");
require("jquery-ui/ui/effects/effect-explode.js");
require("jquery-ui/ui/effects/effect-fade.js");
require("jquery-ui/ui/effects/effect-fold.js");
require("jquery-ui/ui/effects/effect-highlight.js");
require("jquery-ui/ui/effects/effect-pulsate.js");
require("jquery-ui/ui/effects/effect-scale.js");
require("jquery-ui/ui/effects/effect-shake.js");
require("jquery-ui/ui/effects/effect-slide.js");
require("jquery-ui/ui/effects/effect-transfer.js");

// Add Here additionnal datepicker language if needed
require("jquery-ui/ui/i18n/datepicker-de.js");
require("jquery-ui/ui/i18n/datepicker-it.js");
require("jquery-ui/ui/i18n/datepicker-es.js");
require("jquery-ui/ui/i18n/datepicker-pt.js");
require("jquery-ui/ui/i18n/datepicker-ru.js");
require("jquery-ui/ui/i18n/datepicker-ja.js");
require("jquery-ui/ui/i18n/datepicker-en-GB.js");
require("jquery-ui/ui/i18n/datepicker-nl.js");
require("jquery-ui/ui/i18n/datepicker-fr.js");

var language = $('body').attr('lang');
if(language=='en')
	language = 'en-GB';
else if(language=='jp')
	language = 'ja';

if($.datepicker.regional[language])
	$.datepicker.setDefaults( $.datepicker.regional[language] );
else
	$.datepicker.setDefaults( $.datepicker.regional['en-GB'] );

require('./font-awesome.5.15.3/css/all.css');
